import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import { Box } from '@mui/material';

const Sunrise = (props) => {

	const [scrollDir, setScrollDir] = React.useState("scrolling down");
	const [lightPosition, setLightPosition] = React.useState(200);

	const lightsContainerStyling = {
		position: 'relative',
		'&:before': {
			background: 'linear-gradient(180deg, #0F2345 0%, #174A87 82%)',
			content: '""',
			position: 'absolute',
			top: `calc(-${lightPosition}px + 195px)`, // add hills height
			left: 0,
			width: '100%',
			height: '500px',
			zIndex: -1,
		}
	}

	React.useEffect(() => {
	  const threshold = 0;
	  let lastScrollY = window.pageYOffset;
	  let ticking = false;

	  const updateScrollDir = () => {
		const scrollY = window.pageYOffset;

		if (Math.abs(scrollY - lastScrollY) < threshold) {
		  ticking = false;
		  return;
		}
		setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
		lastScrollY = scrollY > 0 ? scrollY : 0;
		ticking = false;
	  };

	  const onScroll = () => {
		if (!ticking) {
		  window.requestAnimationFrame(updateScrollDir);
		  ticking = true;
		}
	  };

	  window.addEventListener("scroll", onScroll);

	  return () => window.removeEventListener("scroll", onScroll);
	}, [scrollDir]);

	const { ref: lightsRef, inView: lightsInView } = useInView({
		/* Optional options */
		threshold: 0,
	});;

	const handleScroll = React.useCallback(() => {
		if(lightsInView) {
			if(scrollDir === 'scrolling down') {
				if(lightPosition < 500) {
					setLightPosition(lightPosition + 2);
				}
			} else {
				if(lightPosition > 200) {
					setLightPosition(lightPosition - 2);
				}
			}
		}
	},[lightsInView, scrollDir, lightPosition]);

	React.useEffect(() => {
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [handleScroll]);

	React.useEffect(() => {

	}, []);

	return (
		<Box sx={lightsContainerStyling} ref={lightsRef} />
	)
}

export default Sunrise;